module.exports = __webpack_public_path__ + "static/logo-cb2df54f8fa6486eb85dea1882663078.svg";